import { Logger } from '@vue-storefront/core';

import getCustomerAccessToken from '../../helpers/internals/getCustomerAccessToken';
import { Context } from '../../types';
import { IUseUserAddressesRefs } from '../types';

const removeUserAddress =
  (context: Context, refs: IUseUserAddressesRefs) => async (addressId: string) => {
    const customerAccessToken = getCustomerAccessToken(context);

    Logger.debug('useUserAddresses/removeUserAddress');

    try {
      refs.loading.value.removeUserAddress = true;

      const response = await context.$shopify.api.removeAddress({
        customerAccessToken,
        id: addressId,
      });

      const data = response.data;

      if (data && !data.customerUserErrors.length && !response.errors) {
        refs.result.value.removeUserAddress = true;
      } else {
        const errors = data?.customerUserErrors || response.errors;

        if (errors) {
          refs.error.value.removeUserAddress = errors;

          Logger.error('useUserAddresses/removeUserAddress/error', errors);
        }
      }
    } catch (error) {
      refs.error.value.removeUserAddress = error as Error;
      Logger.error('useUserAddresses/removeUserAddress/error', error);
    } finally {
      refs.loading.value.removeUserAddress = false;
    }
  };

export default removeUserAddress;
